// One-shot deep-link params for the menu editor. Parsed once on mount and
// applied by each list at its own data-ready moment with silent fallback
// (see spec). menuid/categoryid/productid are NOT stripped from the URL:
// once applied they become state, kept in sync by menus.js's outbound
// writer (see menu-url-state.js). Only optiongroupid is one-shot — it's
// deleted from the URL right after use (see menus.js).
export const parseMenuDeepLink = (searchParams) => ({
  menuid: searchParams.get('menuid') || null,
  categoryid: searchParams.get('categoryid') || null,
  productid: searchParams.get('productid') || null,
  optiongroupid: searchParams.get('optiongroupid') || null,
});
